import React, {useState, useContext, useEffect} from 'react'
import { useNavigate } from 'react-router-dom';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import HighlightBoard from '../Indicator/HighlightBoard';
import WhileLoading from '../Indicator/WhileLoading';
import ImageLabels from './ImageLabels';
import IconButton from '@mui/material/IconButton';
import InfoIcon from '@mui/icons-material/Info';
import ModelInfoCard from '../Dialog/ModalInfoCard';
import ArticleIcon from '@mui/icons-material/Article';
import DataContext from '../Context/DataContext';

export const BasicImageItems = (imagelist) => {
    let navigate = useNavigate();
      const { items } = useContext(DataContext);
    const [imageLoaded, setImageLoaded]=useState(0);
    const [showDetail, setShowDetail] = useState(1);
    const [dayssincedeworming, setDayssincedeworming] = useState("");
    const [dayssinceheat, setDayssinceheat]= useState("");
    const [dayssinceiv, setDayssinceiv] = useState("");
    const [dayssincelastdelivery, setDayssincelastdelivery] = useState("");
    const [dewormingdate, setdewormingdate] = useState("");    
    const [heatdate, setHeatdate] = useState("");    
    const [ivdate, setIvdate] = useState("");
    const [lastdeliverydate, setLastdeliverydate] = useState("");
    const [isMilking, setIsMilking] = useState("");
    const [isPregnant, setIsPregnant] = useState("");
    const [title, setTitle] = useState("");
    const [subtitle, setSubtitle] = useState("");

    const LoadComplete = ()=>{
      
        setImageLoaded(1);
      }

    function closedetail  (data){
      // console.log(data);
      // console.log('showDetail ' + showDetail);
      const selecteditem = items.filter(item => item.cowid === data);
      // console.log(selecteditem);
      if(showDetail === 0) {
        setDayssincedeworming(selecteditem[0].dayssincedeworming);
        setDayssinceheat(selecteditem[0].dayssinceheat);
        setDayssinceiv(selecteditem[0].dayssinceiv);
        setDayssincelastdelivery(selecteditem[0].dayssincelastdelivery);
        setdewormingdate(selecteditem[0].dewormingdate.substring(0, 10));
        setHeatdate(selecteditem[0].heatdate.substring(0, 10));        
        setIvdate(selecteditem[0].ifdate.substring(0, 10));    
        setLastdeliverydate(selecteditem[0].lastdeliverydate.substring(0, 10));   
        if(selecteditem[0].isPregnant === 0 )
          {
            setIsPregnant("False")
          } else {
            setIsPregnant("True");
          } 
        if(selecteditem[0].isMilking === 0){
          setIsMilking("False");
        } else {
          setIsMilking("True");
        }
        setTitle("Cow Detail");
        setSubtitle(selecteditem[0].status + "Tag: " + selecteditem[0].tag);
      } else {
        setDayssincedeworming("");
        setDayssinceheat("");
        setDayssinceiv("");
        setDayssincelastdelivery("");
        setdewormingdate("");
        setHeatdate("");
        setIvdate("");
        setLastdeliverydate("");
        setTitle("");
        setSubtitle("");
      }

    }

    useEffect(()=>{
      const valuetoset = showDetail ? 0 :1;
      setShowDetail(valuetoset);
    }, [dayssincelastdelivery]);

  const cowData = {
  'Deworming Date': dewormingdate,
  'Days since Deworming': dayssincedeworming,
  'Heat Date': heatdate,
  'Days since Heat': dayssinceheat,
  'IV Date' : ivdate,
  'Days since Iv': dayssinceiv,
  'Last Delivery Date': lastdeliverydate,
  'Days since last delivery': dayssincelastdelivery,
  'Is Pregnant': isPregnant,
  'Is Milking' : isMilking
};

  return (
    <>
 {!!showDetail && <ModelInfoCard title={title} subtitle={subtitle} onClose={closedetail} data={cowData} /> }

{imagelist['imagelist'].map((item, index) => (
    <ImageListItem key={index} 
    sx={{
      position: 'relative',
      top: '-30px',
      marginRight:'30px',
      width:'95%',
      // paddingTop:'12px',
      paddingLeft:'10px',
      paddingRightL: '10px',
      // backgroundColor:'pink'
    }}
    >
      <div style={{backgroundColor:'grey', display:'flex', borderTopRightRadius:'2px', borderTopLeftRadius:'2px', 
        flexDirection:'row', justifyContent:'space-evenly'}}>
        <IconButton
        aria-label={'X'}
        sx={{
          color:'white'
        }}
        onClick={
          ()=>{
              closedetail(item[0]);
              // console.log("Hello");
          }
      }
>
    <ArticleIcon />

    </IconButton>
    <div style={{textAlign:'center', fontSize:'14px', flex:1, color:'white', lineHeight:3}}>
      { item[3] + " : "  + item[2] }
    </div>
        <IconButton
        aria-label={'X'}
        sx={{
          color:'white'
        }}
        onClick={
          ()=>{
              navigate("/cowdetail/"+ item[0], { replace: false })
              // console.log("Hello");
          }
      }
>
    <InfoIcon />
    </IconButton>        
      </div>
      {/* <ImageListItemBar 
      title={ item[3] + " : "  + item[2] }
      position="top"
      actionIcon={
        <IconButton
        aria-label={'X'}
        sx={{
          color:'white'
        }}
        onClick={
          ()=>{
              navigate("/cowdetail/"+ item[0], { replace: false })
              // console.log("Hello");
          }
      }
>
    <InfoIcon />
    </IconButton>
      }
      sx={{
        marginLeft:'10px',
        zIndex:900,
        borderTopLeftRadius:7,
        borderTopRightRadius:7
      }}
      /> */}
    <img
          src={`${"https://sasyavatagro.co.in/img/farming/" + item[1]}?w=248&fit=crop&auto=format`}
          srcSet={`${"https://sasyavatagro.co.in/img/farming/" + item[1]}?w=248&fit=crop&auto=format&dpr=2 2x`}
          alt={item[0]}
          loading="lazy"
          onLoad={LoadComplete}          
        />      
    <HighlightBoard cowid={item[0]} isverified={item[14]} ismilking={item[13]}/>        
    {imageLoaded ? <ImageLabels labels={item[item.length-1]} /> :<WhileLoading />}    
    </ImageListItem>
      ))
    }
    </>
  )
}
